





































import { Component, Watch, Emit, Prop } from 'nuxt-property-decorator'
import { ModalComponentBaseVue } from '@/base'
import ModalFooter from '@/components/molecules/ModalFooter/ModalFooter.vue'
import LendOutCollectionTable from '@/components/organisms/LendOutCollectionTable/LendOutCollectionTable.vue'
import { LendCollection, ReserveCollection } from '@/api'
import ReservedCollectionsTable from '@/components/organisms/ReservedCollectionsTable/ReservedCollectionsTable.vue'

@Component({
  components: {
    ReservedCollectionsTable,
    LendOutCollectionTable,
    ModalFooter
  }
})
export default class ModalFamilyUsageSituation extends ModalComponentBaseVue {
  @Prop({
    type: Array,
    required: true
  })
  lendCollections!: LendCollection[]

  @Prop({
    type: Array,
    required: true
  })
  reserveCollections!: ReserveCollection[]

  dialog: boolean = false

  tableBodyHeight: number = 0

  @Watch('dialog')
  initialize(): void {
    if (this.dialog) {
      return this.$nextTick(this.calculateTableHeight)
    } else {
      this.tableBodyHeight = 0
    }
  }

  @Watch('dialog')
  onShowChanged(val: boolean) {
    console.log('ModalFamilyUsageSituation - onShowChanged - ', val)

    if (val) return this.opened()

    this.closed()
  }

  mounted() {
    this.debug('mounted()')
    window.addEventListener('resize', this.onResize)
  }

  beforeDestroy() {
    this.debug('beforeDestroy()')
    window.removeEventListener('resize', this.onResize)
  }

  open(): void {
    this.dialog = true
  }

  close(): void {
    this.dialog = false
  }

  calculateTableHeight(): void {
    this.tableBodyHeight = 0

    this.$nextTick(() => {
      this.tableBodyHeight = this.calculateTableHeightBase() / 2
    })
  }

  onClickPrint(): void {
    const element = document.getElementById('modal-family-usage-situation')
    if (element) {
      this.$webSocket.sendDialogScreenshotMessage(element)
    } else {
      this.$webSocket.sendScreenshotMessage()
    }
  }

  onResize(): void {
    this.calculateTableHeight()
  }

  @Emit('opened')
  opened(): void {
    console.log('ModalFamilyUsageSituation - opened')
  }

  @Emit('closed')
  closed(): void {
    console.log('ModalFamilyUsageSituation - closed')
  }
}
